import { compose } from 'redux'

// higher order components
import withRedux from './withRedux'
import withEventHandlers from './withEventHandlers'

export default compose(
  withRedux,
  withEventHandlers
)
